import { Alert, Button, Col, ControlLabel, DropdownButton, Form, FormControl, FormGroup, MenuItem, Panel, Row } from 'react-bootstrap'
import { AddEditWrapper } from './styles'
import AdminSection from './admin-section'
import { VoucherHolderAction } from '../voucher-holder-action'
import { IAddEditData } from './add-edit-data'
import { IListItem } from '@nkr/models/index'
import { IValidation } from './validation'
import { FormEvent } from 'react'
import MaskedInput from 'react-maskedinput';

interface IProps {
    data: IAddEditData,
    voucherHolderId: number,
    isAdmin: boolean,
    isAdminLogin: boolean,
    isValid: boolean,
    validation: IValidation,
    dirty: boolean,
    genderList: IListItem[],
    countryList: IListItem[],
    aboTypeList: IListItem[],
    ckdStatusList: IListItem[],
    voucherHolderStatusList: IListItem[],
    voucherHolderTypeList: IListItem[],
    showActions: boolean,
    onAction: (eventKey: any) => void,
    onFieldChange: (field: string, value: any) => void,
    onSave: () => void,
    onCancel: () => void
}

const AddEditForm = (props: IProps) => {
    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { id, value } = e.currentTarget;
        props.onFieldChange(id, value);
    };

    return (
        <AddEditWrapper className='container'>
            {!props.isValid && (
                <Alert bsStyle='danger' bsSize='sm'>Please specify the items in red below...</Alert>
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10, marginBottom: 10 }}>
                {/* <h1 className='text-left' style={{ margin: 0 }}>{props.voucherHolderId == 0 ? 'Add' : 'Edit'} Voucher</h1> */}
                <div className="dropdown pull-right">
                    {props.voucherHolderId > 0 && props.showActions && (
                        <DropdownButton id='voucher-edit-actions' title='Actions' onSelect={props.onAction}>
                            {props.isAdmin || props.isAdminLogin
                                && <MenuItem eventKey={VoucherHolderAction.OrderBuccalSwabKit}>Order Buccal Swab Kit</MenuItem>
                            }

                            {props.isAdmin || props.isAdminLogin
                                && <MenuItem eventKey={VoucherHolderAction.OrderLabScreening}>Order Lab Screening</MenuItem>
                            }

                            <MenuItem eventKey={VoucherHolderAction.ResendLink}>Re-send Invite</MenuItem>

                            <MenuItem divider />

                            <MenuItem eventKey={VoucherHolderAction.StartRedemption}>Start Redemption</MenuItem>

                            <MenuItem divider />

                            <MenuItem eventKey={VoucherHolderAction.UploadVoucherConsent}>Upload Voucher Consent</MenuItem>
                            <MenuItem eventKey={VoucherHolderAction.UploadSwabResults}>Upload Swab Results</MenuItem>
                            <MenuItem eventKey={VoucherHolderAction.UploadScreeningResults}>Upload Screening Results</MenuItem>
                        </DropdownButton>
                    )}
                </div>
            </div>

            {(props.isAdmin || props.isAdminLogin) && props.voucherHolderId > 0 && (
                <AdminSection
                    abo={props.data.abo}
                    ckdStatus={props.data.ckdStatus}
                    status={props.data.status}
                    aboTypeList={props.aboTypeList}
                    ckdStatusList={props.ckdStatusList}
                    voucherHolderStatusList={props.voucherHolderStatusList}
                    onFieldChange={handleFieldChange}
                />
            )}

            <Panel>
                <Panel.Body>
                    <Form horizontal>
                        <FormGroup validationState={props.dirty && !props.validation.type ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Type:</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    componentClass='select'
                                    id='type'
                                    value={props.data.type}
                                    onChange={handleFieldChange}
                                >
                                    <option value={0}>- Please Select -</option>
                                    {props.voucherHolderTypeList.map(item =>
                                        <option key={'type-' + item.id} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.gender ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Gender:</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    componentClass='select'
                                    id='gender'
                                    value={props.data.gender}
                                    onChange={handleFieldChange}
                                >
                                    <option value={0}>Unknown</option>
                                    {props.genderList.map(item =>
                                        <option key={'gender-' + item.id} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.firstName ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>First Name:</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    id='firstName'
                                    value={props.data.firstName}
                                    onChange={handleFieldChange} />

                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.lastName ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Last Name:</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    id='lastName'
                                    value={props.data.lastName}
                                    onChange={handleFieldChange} />

                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.country ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Country:</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    componentClass='select'
                                    id='country'
                                    value={props.data.country}
                                    onChange={handleFieldChange}
                                >
                                    {props.countryList.map(item =>
                                        <option key={'country-' + item.id} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.addressLine1 ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Address (line 1):</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    id='addressLine1'
                                    value={props.data.addressLine1}
                                    onChange={handleFieldChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Address (line 2): <span className='label label-warning'>optional</span></Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    id='addressLine2'
                                    value={props.data.addressLine2}
                                    onChange={handleFieldChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.city ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>City:</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    id='city'
                                    value={props.data.city}
                                    onChange={handleFieldChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.stateProvince ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>State/Province:</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    id='stateProvince'
                                    value={props.data.stateProvince}
                                    onChange={handleFieldChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.postalCode ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Postal Code:</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    id='postalCode'
                                    value={props.data.postalCode}
                                    onChange={handleFieldChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.phoneNumberPrimary ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Phone Number (primary):</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    id='phoneNumberPrimary'
                                    value={props.data.phoneNumberPrimary}
                                    onChange={handleFieldChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Phone Number (secondary): <span className='label label-warning'>optional</span></Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    id='phoneNumberSecondary'
                                    value={props.data.phoneNumberSecondary}
                                    onChange={handleFieldChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.emailPrimary ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Email (primary):</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    id='emailPrimary'
                                    value={props.data.emailPrimary}
                                    onChange={handleFieldChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.emailSecondary ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Email (secondary): <span className='label label-warning'>optional</span></Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    id='emailSecondary'
                                    value={props.data.emailSecondary}
                                    onChange={handleFieldChange} />
                            </Col>
                        </FormGroup>

                        <FormGroup style={{ marginBottom: 0 }} validationState={props.dirty && !props.validation.birthDate ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Birthdate:</Col>
                            <Col xs={12} lg={6}>
                                <MaskedInput
                                    id='birthDate'
                                    className='form-control'
                                    mask='11/11/1111'
                                    placeholder='mm/dd/yyyy'
                                    style={{ borderColor: props.validation.birthDate ? '#ccc' : '#a94442' }}
                                    value={props.data.birthDate}
                                    onChange={handleFieldChange}
                                />
                            </Col>
                        </FormGroup>
                    </Form>
                </Panel.Body>
            </Panel>

            <Row>
                <Col xs={12} lg={3} lgOffset={3}>
                    <Button bsStyle='primary' block onClick={props.onSave}>Save</Button>
                </Col>
                <Col xs={12} lg={3}>
                    <Button block onClick={props.onCancel}>Cancel</Button>
                </Col>
            </Row>
        </AddEditWrapper>
    );
}

export default AddEditForm;